import React from 'react';
import { Select, SelectProps } from 'antd';
import { useQuery } from 'react-query';
import { noop } from 'lodash';
import { getParCalendarList } from 'services/parametersService';

export type ParCalendarSelectProps  = SelectProps<any> & {
  calid: number;
  disabled?: boolean;
  allowClear?: boolean;
  style?: any;
  onSelected?: any;
};

const ParCalendarSelect = ({
  calid,
  onSelected,
  onChange = noop,
  ...otherProps
}: ParCalendarSelectProps) => {
    const { data, refetch } = useQuery(
      ['getParCalendarList',calid],
      () => getParCalendarList().then((res) => res.list || []),
      {enabled: true }
    );


  const handleChange: SelectProps<any>['onChange'] = (value, option) => {
    onChange(value, option);
    if (onSelected) {
      onSelected(data?.find((item:any) => item?.calid === value)!);
    }
  };
  return (
    <Select {...otherProps} onChange={handleChange}>
      {(data?.map((calendar:any) => (
        <Select.Option value={calendar.calid} key={calendar.calid}>
          {calendar.callabel + ' - ' + calendar.countcode}
        </Select.Option>
      )))}
      
    </Select>
  );
};

export default ParCalendarSelect;
